export default function useDataService() {
  const mailerMethodItems = [
    {
      id: 'default',
      label: 'Default',
    },
    {
      id: 'custom',
      label: 'Custom',
    },
  ];

  const smtpAuthenticationItems = [
    {
      id: 'plain',
      label: 'Plain',
    },
    {
      id: 'login',
      label: 'Login',
    },
    {
      id: 'cram_md5',
      label: 'Cram-MD5',
    },
  ];

  const smtpSecurityItems = [
    {
      id: 'none',
      label: 'None',
    },
    {
      id: 'start_tls',
      label: 'Start TLS',
    },
    {
      id: 'ssl',
      label: 'SSL',
    },
  ];

  const smtpTestPeriodicityItems = [
    {
      id: 'daily',
      label: 'Daily',
    },
    {
      id: 'weekly',
      label: 'Weekly',
    },
    {
      id: 'monthly',
      label: 'Monthly',
    },
  ];

  return {
    mailerMethodItems,
    smtpAuthenticationItems,
    smtpSecurityItems,
    smtpTestPeriodicityItems,
  };
}
